export default function detectMp4(mediaSrc) {
  if (!mediaSrc) return false
  const sourceSplit = mediaSrc.split('.')
  return sourceSplit[sourceSplit.length - 1] === 'mp4'
}
